import React, { memo } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

const TextInput = (props)=>{
  const  {
    type,
    item,
    className,
    validationForms,
    fieldObj
  } = props;
  const attr = formFieldsAttributes(
    {...item,className:className},
    validationForms
    );
  return(
    <FormBlocks {...props} attr={attr}>
        {/* <form autoComplete="off"> */}
          <input 
            type={type}
            value={attr.value}
            onChange={(e) =>props.onChangeInputAction(fieldObj,e)}
            onBlur={(e)=>props.onBlurHandlerAction(fieldObj,e)}
            {...attr.fieldAttributes}
          />
          {/* </form> */}
      </FormBlocks>
  )
};
TextInput.defaultProps = {
  generator: false,
  className: "form-control"
}
const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}
export default memo(TextInput,isDiffProps);
